export default __webpack_public_path__ + "static/media/15g30mmsb.127dcc29.jpeg";